// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioMark_root__2L1So","normal":"RadioMark_normal__6G8kH","large":"RadioMark_large__21_IV","disabled":"RadioMark_disabled__3-N3O"};